import * as React from 'react';

export default function MenuIcon({
  className,
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      className={className}
      aria-hidden='true'
      {...rest}
    >
      <line
        x1='4'
        y1='7'
        x2='20'
        y2='7'
        strokeWidth='1.75'
        strokeLinecap='round'
      />
      <line
        x1='4'
        y1='12'
        x2='20'
        y2='12'
        strokeWidth='1.75'
        strokeLinecap='round'
      />
      <line
        x1='4'
        y1='17'
        x2='20'
        y2='17'
        strokeWidth='1.75'
        strokeLinecap='round'
      />
    </svg>
  );
}
